import { graphql } from "babel-plugin-relay/macro";

export const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment moduleRating_ContentSubmissionFragment on ContentSubmission {
		learnOpportunity {
			root {
				id
			}
		}
	}
`;

export const CREATE_MODULE_RATING_MUTATION = graphql`
	mutation moduleRating_createModuleRatingSubmissionMutation($input: CreateModuleRatingInput!) {
		ModuleRating {
			createModuleRating(input: $input) {
				edge {
					node {
						id
						value
					}
				}
			}
		}
	}
`;

export const QUERY = graphql`
	query moduleRating_Query($nodeRef: ID!) {
		ModuleRating {
			GetModuleRatingOptByNodeAndUserRef(nodeRef: $nodeRef) {
				id
				value
			}
		}
	}
`;
